<svg id="Ebene_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 510.23 247.38"
    ><defs
        ><style>
            .cls-1 {
                fill: #e6007e;
            }
            .cls-2 {
                fill: #1d1d1b;
            }
        </style></defs
    ><g id="Ebene_1-2"
        ><g
            ><path
                class="cls-2"
                d="M193.54,153.95c-38.17,0-86.14-22.81-92.97-56.31,.05,.12,97,0,96.98,0,54.54,.28,88.05,21.79,96.21,56.31-.04-.01-100.24,0-100.22,0Zm100.93,32.55c-7.4,42.88-46.98,60.88-99.89,60.88-39.54,0-77.69-12.46-103.23-28.63l32.89-51.2c17.85,11.79,48.99,18.95,71.74,18.95,.01,0,98.46,.02,98.49,0ZM99.95,64.98C106.86,28.1,142.38,4.17,195.28,4.17c41.64,0,72.83,8.28,98.73,25.79l-32.89,51.2c-21.7-14.15-44.48-16.18-69.33-16.18-.02-.02-91.83-.02-91.84,0Z"
            /><g
                ><polygon
                    points="389.83 153.95 462.27 153.95 462.27 97.61 389.83 97.61 389.83 97.6 322.64 97.6 322.64 153.96 389.83 153.96 389.83 153.95"
                /><polygon
                    points="389.83 186.57 389.83 186.51 322.64 186.51 322.64 243.61 510.23 243.61 510.23 186.57 389.83 186.57"
                /><rect x="322.64" y="8.02" width="187.57" height="56.93" /></g
            ><rect class="cls-2" x="3.36" y="97.6" width="62.29" height="145.93" /><circle
                class="cls-1"
                cx="34.5"
                cy="34.5"
                r="34.5"
            /></g
        ></g
    ></svg
>
